import { ELITKLINIK_PROJECTS, ELITKLINIK_PROJECTS_HEADER_KEYS } from "@elit-hair/elitklinik-shared";
import axios from "axios";

import useAuth from "@/providers/hooks/useAuth";

export const useGetNotificationAxiosInstance = () => {
    const { auth } = useAuth();
    const url = (import.meta.env.VITE_NOTIFICATION_BASE_URL || "http://localhost:9006/api") + "/notification-svc";

    return axios.create({
        baseURL: url,
        headers: {
            Authorization: auth?.accessToken,
            [ELITKLINIK_PROJECTS_HEADER_KEYS.APP]: ELITKLINIK_PROJECTS.TRANSPORT,
        },
    });
};

export enum LocaleStorageKeys {
    HIDDEN_DRIVERS = "hdn_drvs",
    SHIFT_NOTIFY = "shft_ntfy",
    SHIFT_FLOATING_ACTION_BUTTON = "shft_fab",
    PLAN_GRID_SETTINGS = "pln_grd_stngs",
    TRACKING_GRID_SETTINGS = "trck_grd_stngs",
    CLINIC_ARRIVAL_UNASSIGNED_GRID_SETTINGS = "clnc_arr_unas_grd",
    CLINIC_ARRIVAL_TASKS_GRID_SETTINGS = "clnc_arr_tsks_grd",
    FCM_TOKEN = "fcm_token",
}

export const QUERY_KEYS = {
    GET_DRIVERS: "GET_DRIVERS",
    GET_DRIVER_CAMERAS: "GET_DRIVER_CAMERAS",
    GET_VEHICLES: "GET_VEHICLES",
    GET_PASSENGERS: "GET_PASSENGERS",
    GET_TASKS: "GET_TASKS",
    GET_PATIENT: "GET_PATIENT",
    GET_TASK: "GET_TASK",
    GET_DRIVERS_TASKS: "GET_DRIVERS_TASKS",
    GET_CUSTOM_PASSENGER: "GET_CUSTOM_PASSENGER",
    GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
    GET_UNREAD_COUNT: "GET_UNREAD_COUNT",
    GET_PASSENGER_HISTORY: "GET_PASSENGER_HISTORY",
    GET_FORMATTED_PASSENGER: "GET_FORMATTED_PASSENGER",
    // GET_NOTIFICATIONS_UNREAD: "GET_NOTIFICATIONS_UNREAD",
    GET_LOCATIONS: "GET_LOCATIONS",
    GET_MAP_ZONES: "GET_MAP_ZONES",
    UETDS_REGISTER: "UETDS_REGISTER",
    UETDS_CANCELL: "UETDS_CANCELL",
    GET_ARRIVALS: "GET_ARRIVALS",
    GET_SHIFTS: "GET_SHIFTS",
    GET_CURRENT_SHIFT: "GET_CURRENT_SHIFT",
    GET_DAILY_STATUS_REPORTS: "GET_DAILY_STATUS_REPORTS",
    GET_PASSENGER_SEARCH: "GET_PASSENGER_SEARCH",

    GET_DRIVER_METADATA_SCHEMA: "GET_DRIVER_METADATA_SCHEMA",
    GET_HOTEL_PLANNING: "GET_HOTEL_PLANNING",
    GET_USERS: "GET_USERS",
    GET_HOTEL_DEPARTURE_PLANNING: "GET_HOTEL_DEPARTURE_PLANNING",
    GET_HOTEL_DEPARTURE_CUSTOM_PASSENGERS: "GET_HOTEL_DEPARTURE_CUSTOM_PASSENGERS",
    GET_HOTEL_CLINIC_TASKS_BY_DATE: "GET_HOTEL_CLINIC_TASKS_BY_DATE",

    // Dashboard
    GET_DASHBOARD_INVENTORY: "GET_DASHBOARD_INVENTORY",
    GET_DASHBOARD_PASSENGER_LAST_ACTIVITY: "GET_DASHBOARD_PASSENGER_LAST_ACTIVITY",
    GET_DASHBOARD_TASKS_SUMMARY: "GET_DASHBOARD_TASKS_SUMMARY",
} as const;

export const useGetTransportAxiosInstance = () => {
    const { auth } = useAuth();

    const url = (import.meta.env.VITE_API_BASE_URL || "https://api.elitklinik.io/api") + "/transport-svc";

    return axios.create({
        baseURL: url,
        headers: {
            Authorization: auth?.accessToken,
            [ELITKLINIK_PROJECTS_HEADER_KEYS.APP]: ELITKLINIK_PROJECTS.TRANSPORT,
        },
    });
};

export const accServiceBaseUrl =
    (import.meta.env.VITE_API_ACC_SERVICE_URL || "https://api.elitklinik.io/api") + "/acc-svc";

export const checkpointServiceBaseUrl =
    (import.meta.env.VITE_API_CHECKPOINT_SERVICE_URL || "https://test.elitklinik.io/api") + "/checkpoint-svc/tr/";

export const useGetCheckpointServiceAxiosInstance = () => {
    const { auth } = useAuth();

    return axios.create({
        baseURL: checkpointServiceBaseUrl,
        headers: {
            Authorization: auth?.accessToken,
            [ELITKLINIK_PROJECTS_HEADER_KEYS.APP]: ELITKLINIK_PROJECTS.TRANSPORT,
        },
    });
};

export const useGetAccServiceAxiosInstance = () => {
    const { auth } = useAuth();

    return axios.create({
        baseURL: accServiceBaseUrl,
        headers: {
            Authorization: auth?.accessToken,
            [ELITKLINIK_PROJECTS_HEADER_KEYS.APP]: ELITKLINIK_PROJECTS.TRANSPORT,
        },
    });
};

export const ELITKLINIK_COORDS = { lat: 41.10272618060195, lng: 28.982208950720977 };

export { TASK_STATUS } from "./status";

export enum Airports {
    IST = "IST",
    SAW = "SAW",
}
export const AIRPORTS = Object.values(Airports);
